/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Cargo_Supervision_TitleInputs */



/**
* | output |
* | --- |
* | "Cargo supervision" |
*
* @param {Service_Cargo_Supervision_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_cargo_supervision_title = /** @type {((inputs?: Service_Cargo_Supervision_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Cargo_Supervision_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("货物监装监卸")
	return /** @type {LocalizedString} */ ("Cargo supervision")
});